// FieldTooltip — HelpCircle icon with Radix tooltip popup.
// Background: een-navy (#021526). Text: een-sky (#CEECF8).

import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { HelpCircle } from 'lucide-react';

interface FieldTooltipProps {
  text: string;
}

export function FieldTooltip({ text }: FieldTooltipProps) {
  return (
    <TooltipPrimitive.Root delayDuration={200}>
      <TooltipPrimitive.Trigger asChild>
        <button
          type="button"
          aria-label="Help"
          data-tooltip-icon
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '18px',
            height: '18px',
            background: 'rgba(206,236,248,0.12)',
            border: '1px solid rgba(206,236,248,0.2)',
            borderRadius: '50%',
            padding: 0,
            marginLeft: '4px',
            cursor: 'pointer',
            color: '#CEECF8',
            verticalAlign: 'middle',
            lineHeight: 1,
          }}
        >
          <HelpCircle size={13} />
        </button>
      </TooltipPrimitive.Trigger>

      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side="top"
          sideOffset={5}
          style={{
            backgroundColor: 'rgba(206,236,248,0.12)',
            color: '#CEECF8',
            fontSize: '12px',
            lineHeight: '1.5',
            padding: '8px 12px',
            borderRadius: '6px',
            maxWidth: '280px',
            border: '1px solid rgba(206,236,248,0.2)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
            backdropFilter: 'blur(12px)',
            zIndex: 9999,
          }}
        >
          {text}
          <TooltipPrimitive.Arrow style={{ fill: 'rgba(206,236,248,0.12)' }} />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}

// Wrap the whole app (or subtree) with this provider once at the root.
export { TooltipPrimitive };
